import { P2GBox } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { ReactNode } from 'react';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { LinkApiModel } from '~/lib/api/smartsend/types';
import { useLocalStorage } from '../../../../hooks/useLocalStorage';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  action?: ReactNode;
  button: ReactNode;
  terms?: string;
  isXs: boolean;
  termsLink?: LinkApiModel[];
}

const ServiceTerms: React.FC<{ link: LinkApiModel; onToggle: () => void; selected: boolean }> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const company = props.link.Type?.split(':')[1] || '';
  return (
    <P2GBox>
      <P2GCheckBoxLegacy
        id="service-terms-checkbox"
        checked={props.selected}
        onChange={props.onToggle}
        label={
          <P2GText variant="body2">
            <Trans
              i18nKey="TERMS_INPUT_LABEL"
              t={t}
              components={{
                a: <P2GLink href={props.link.Href} target="_blank" />
              }}
              values={{ company: company }}
              defaults="Please confirm you have read, understood and accept the {{company}} <a>terms and conditions</a>."
            />
          </P2GText>
        }
        labelPlacement="end"
        variant="primary"
        error={false}
      />
    </P2GBox>
  );
};

export default function TermsRow(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [termsState, setTermsState] = useLocalStorage<{ [name: string]: boolean }>('SERVICE-TERMS', {});
  const allAgreed = useMemo(() => props.termsLink?.every((x) => termsState[x.Type]), [props.termsLink, termsState]);
  const hasLinks = props.termsLink && props.termsLink.length > 0;
  const button =
    !hasLinks || allAgreed ? (
      props.button
    ) : (
      <P2GButton disabled>{t('TERMS_ROW_CONTINUE_BUTTON', { defaultValue: 'Continue' })}</P2GButton>
    );

  return (
    <P2GBox textAlign={props.isXs ? 'center' : 'left'} pt={props.isXs ? 5 : 0}>
      {hasLinks && (
        <P2GBox mb={2}>
          {props.termsLink?.map((x) => (
            <ServiceTerms
              key={x.Type}
              link={x}
              selected={termsState[x.Type]}
              onToggle={() => setTermsState({ ...termsState, [x.Type]: !termsState[x.Type] })}
            />
          ))}
        </P2GBox>
      )}
      {props.action === null ? (
        <P2GBox>{button}</P2GBox>
      ) : (
        <P2GGrid container spacing={2} direction="column">
          <P2GGrid item>
            {props.action || (
              <>
                {(props.terms || SettingsCache.settings.Links.TermsAndConditions) && (
                  <P2GText variant="body2">
                    <Trans
                      i18nKey="TERMS_DESCRIPTION"
                      t={t}
                      components={{
                        terms: (
                          <P2GLink
                            href={props.terms || SettingsCache.settings.Links.TermsAndConditions}
                            target="_blank"
                          />
                        )
                      }}
                      defaults="By booking your parcels you accept all <terms>terms of use</terms>."
                    />
                  </P2GText>
                )}
              </>
            )}
          </P2GGrid>
          <P2GGrid item>{button}</P2GGrid>
        </P2GGrid>
      )}
    </P2GBox>
  );
}
